import React from "react";
import { ButtonNew as Button } from "components/buttonNew";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import useModal from "hooks/modals/useModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-regular-svg-icons";
import { WebsiteBuilderSelectMedia } from "../../../helpers/WebsiteBuilderSelectMedia";
import { TWebsiteBuilderSectionBackgroundMediaType } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";
import { isWebsiteBuilderVideoAllowedFileSubtype } from "pages/secure/facility/websiteBuilder/editor/utility/websiteBuilderAllowedMedia";

interface ISectionSettingsBackgroundMediaProps {
  mediaId: number;
  src: string;
  mediaType: TWebsiteBuilderSectionBackgroundMediaType;
  handleUpdateBackgroundMedia: (mediaId: number, src: string, mediaType: TWebsiteBuilderSectionBackgroundMediaType) => void;
}

export function SectionSettingsBackgroundMedia(props: ISectionSettingsBackgroundMediaProps) {
  const { mediaId, src, mediaType, handleUpdateBackgroundMedia } = props;
  
  const { t } = useTranslation();
  
  const { state: selectMediaModalState, updateModal: updateSelectMediaModal, closeModal: closeSelectMediaModal } = useModal();
  
  function handleOpenSelectMediaModal() {
    updateSelectMediaModal({ isOpen: true });
  }

  function handleCloseSelectMediaModal() {
    closeSelectMediaModal();
  }

  function handleSelectMedia(media: IWebsiteBuilderMediaItem) {
    handleUpdateBackgroundMedia(
      media.id,
      media.source,
      isWebsiteBuilderVideoAllowedFileSubtype(media.subtype) ? "video" : "image",
    );
    handleCloseSelectMediaModal();
  }

  function handleClearMedia() {
    handleUpdateBackgroundMedia(null, null, mediaType);
  }

  return (
    <div className="website-builder-section-settings-background-media">
      <div
        className={classNames("background-media-container", {
          "no-src-border": !src,
        })}
      >
        {src && (
          <>
            {mediaType === "video" ? (
              <video
                src={src}
                preload="metadata"
                muted
                playsInline
                disablePictureInPicture
              />
            ) : (
              <img src={src} />
            )}
            <FontAwesomeIcon
              className="background-media-close-icon"
              icon={faClose}
              onClick={handleClearMedia}
            />
          </>
        )}
      </div>
      <div className="background-media-action-container">
        <Button size="xsmall" onClick={handleOpenSelectMediaModal}>{t("Set background")}</Button>
      </div>
      <WebsiteBuilderSelectMedia
        type="both"
        mediaId={mediaId}
        isOpen={selectMediaModalState.isOpen}
        closeModal={handleCloseSelectMediaModal}
        handleSelectMedia={handleSelectMedia}
      />
    </div>
  );
}
